import "./input-group.css.js";
const i = {
  inputGroup: "pf-v6-c-input-group",
  inputGroupItem: "pf-v6-c-input-group__item",
  inputGroupText: "pf-v6-c-input-group__text",
  modifiers: {
    box: "pf-m-box",
    plain: "pf-m-plain",
    disabled: "pf-m-disabled",
    fill: "pf-m-fill"
  }
};
export {
  i as default
};
